import type { Editor } from "@tiptap/core";

export const updateDirectiveTokenRawAtPos = (
  editor: Editor,
  pos: number,
  raw: string,
  options?: { focus?: boolean },
): boolean => {
  const focus = options?.focus !== false;
  const node = editor.state.doc.nodeAt(pos);
  if (node?.type.name !== "variableToken") return false;
  // focus:false: avoid setNodeSelection so partial sync does not pull focus into ProseMirror
  if (!focus) {
    const { tr } = editor.state;
    tr.setNodeMarkup(pos, undefined, { ...node.attrs, raw });
    editor.view.dispatch(tr);
    return true;
  }
  editor
    .chain()
    .focus()
    .setNodeSelection(pos)
    .updateAttributes("variableToken", { raw })
    .run();
  return true;
};

export const finalizeDirectiveTokenRawAtPos = (
  editor: Editor,
  pos: number,
  raw: string,
): boolean => {
  const node = editor.state.doc.nodeAt(pos);
  if (node?.type.name !== "variableToken") return false;
  const end = pos + node.nodeSize;
  editor
    .chain()
    .focus()
    .setNodeSelection(pos)
    .updateAttributes("variableToken", { raw })
    .setTextSelection(end)
    .run();
  return true;
};
